import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bycullatopunecab() {



const cardData = {
  keyword: " Byculla to Pune Cab Service  ",

headingDescription: "Velocity Cab provides reliable and comfortable Byculla to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Byculla to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Byculla to Pune cab travel.",

topPlaces: [

  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a magnificent heritage monument associated with India's freedom movement. Visitors can explore its elegant architecture, peaceful gardens, and museum dedicated to Mahatma Gandhi while learning about Pune's historical significance."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut Shiva temple carved from a single basalt rock. Its tranquil surroundings and remarkable architecture make it a popular destination for spirituality, history, and photography."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a scenic riverside park offering lush greenery, boating opportunities, and peaceful walking paths. It is a perfect place for families, couples, and nature lovers seeking relaxation."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is one of Pune's oldest landmarks, offering panoramic city views from its historic temple complex. Travelers can climb the stone steps, visit ancient shrines, and enjoy breathtaking scenery."
  },
    {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautifully landscaped Japanese-style garden featuring serene ponds, lush greenery, and elegant walking paths. Travelers booking a sedan cab in Pune can enjoy peaceful strolls, scenic photography, and a relaxing escape from the city's busy streets."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular recreational garden in Pune featuring beautifully maintained lawns and the famous Siddhivinayak Temple. Visitors can relax amidst nature, enjoy leisurely walks, and experience one of the city's favorite family-friendly destinations."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum is home to thousands of rare artifacts, traditional musical instruments, sculptures, and decorative objects representing India's rich cultural heritage. It offers an enriching experience for history and art enthusiasts."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is Pune's iconic historical fort and a symbol of the Maratha Empire. Visitors can explore its grand gateways, historic ruins, and captivating light and sound show that showcases the city's rich heritage."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a premier shopping and entertainment destination featuring international brands, restaurants, cinemas, and family-friendly attractions, making it ideal for a day of leisure."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic getaway on the outskirts of Pune, popular for its peaceful waterfront views, beautiful sunsets, and relaxing atmosphere. It is an excellent destination for picnics and photography."
  }
],



services: [
{
name: "Byculla to Pune Cab Service Rates",
description: "Byculla to Pune cab service offers reliable and budget-friendly intercity travel with transparent pricing and premium comfort. Travelers can choose from sedan, Ertiga, and Innova Crysta vehicles depending on their group size and travel needs. The route via the Mumbai–Pune Expressway ensures fast and smooth connectivity between South Mumbai and Pune. Professional drivers provide timely pickup from Byculla East, West, railway station, offices, and residential complexes. This service is ideal for corporate travel, family trips, and tourist visits. Air-conditioned vehicles, spacious seating, and luggage space ensure a comfortable long-distance journey. Easy online booking with instant confirmation makes travel planning hassle-free."
},
{
name: "Byculla to Pune Taxi Service",
description: "Byculla to Pune taxi service provides convenient and dependable transportation between South Mumbai and Pune city. Travelers can enjoy comfortable rides in well-maintained vehicles with professional drivers ensuring safe highway travel. Pickup is available from homes, hotels, and commercial areas across Byculla. This service is widely used for business trips, airport transfers, and weekend travel. Smooth expressway connectivity ensures a quick and stress-free journey."
},
{
name: "Mahalaxmi to Pune Cab Service",
description: "Mahalaxmi to Pune cab service offers premium and reliable travel between Mahalaxmi in Mumbai and Pune. Travelers can book comfortable vehicles such as sedan, Ertiga, and Innova for smooth expressway journeys. Professional drivers provide punctual pickups from offices, homes, and commercial hubs in Mahalaxmi. This service is popular among corporate travelers and families heading to Pune."
},
{
name: "Colaba to Pune Taxi",
description: "Colaba to Pune taxi service provides convenient long-distance transportation from South Mumbai’s Colaba area to Pune. Travelers can enjoy comfortable rides in air-conditioned vehicles with experienced drivers ensuring safe and smooth expressway travel. This service is ideal for tourists, corporate professionals, and families traveling to Pune."
},
{
name: "Parel to Pune Cab Service",
description: "Parel to Pune cab service offers dependable transportation between central Mumbai and Pune. Travelers can book comfortable vehicles with professional drivers ensuring safe highway travel. This route is commonly used by corporate travelers and residents traveling between Mumbai and Pune."
},
{
name: "Sion to Pune Cab Booking",
description: "Sion to Pune cab booking service provides quick and easy transportation between Sion in Mumbai and Pune city. Travelers can book taxis online with instant confirmation and transparent pricing. Comfortable vehicles and professional drivers ensure smooth expressway journeys."
},
{
name: "Wadala to Pune Cab Booking",
description: "Wadala to Pune cab service offers reliable intercity travel with comfortable vehicles and experienced drivers. Travelers can enjoy smooth highway journeys with timely pickups from Wadala residential and commercial areas."
},
{
name: "Byculla Cabs Service",
description: "Byculla cab service provides reliable transportation for city travel, airport transfers, and outstation journeys. Travelers can book comfortable vehicles with experienced drivers for safe travel across Mumbai and nearby destinations including Pune."
},
{
name: "Outstation Cab Service in Byculla",
description: "Outstation cab service in Byculla provides long-distance travel to destinations such as Pune, Nashik, and Lonavala. Travelers can book comfortable vehicles with professional drivers ensuring safe and convenient travel."
},
{
name: "Outstation Cab Service in Byculla Number",
description: "Outstation cab service in Byculla contact number helps passengers quickly connect with reliable cab providers for booking taxis. Travelers can easily arrange comfortable rides for Pune trips and other destinations."
},
{
name: "Outstation Cab Service in Byculla Number Mumbai",
description: "Outstation cab service in Byculla Mumbai provides easy access to reliable taxi booking services for long-distance travel. Travelers can contact service providers to book comfortable vehicles for Pune journeys."
},
{
name: "Byculla to Pune Cab",
description: "Byculla to Pune cab service offers dependable intercity transportation with comfortable vehicles and professional drivers ensuring safe and smooth travel."
},
{
name: "Byculla to Pune Cab Service",
description: "Byculla to Pune cab service provides reliable long-distance travel with flexible pickup options and smooth expressway connectivity."
},
{
name: "Byculla to Pune Taxi Service",
description: "Byculla to Pune taxi service offers convenient travel with experienced drivers and comfortable vehicles ensuring a pleasant journey."
},
{
name: "Byculla to Pune One Way Cab",
description: "Byculla to Pune one way cab service provides economical travel for passengers requiring single-direction transportation between Mumbai and Pune."
},
{
name: "Byculla to Pune Taxi Fare",
description: "Byculla to Pune taxi fare service provides transparent pricing helping travelers plan their travel budget efficiently."
},
{
name: "Byculla to Pune Cab Booking",
description: "Byculla to Pune cab booking allows passengers to easily reserve taxis online with instant confirmation and flexible travel timing."
},
{
name: "Cab from Byculla to Pune",
description: "Cab from Byculla to Pune offers reliable transportation with comfortable vehicles and experienced drivers ensuring safe long-distance travel."
},
{
name: "Byculla to Pune Car Rental",
description: "Byculla to Pune car rental service provides flexible travel options with a variety of vehicles available for intercity journeys."
},
{
name: "Byculla to Pune Taxi Booking Online",
description: "Byculla to Pune taxi booking online allows travelers to book cabs instantly through digital platforms with transparent pricing and quick confirmation."
},
{
name: "Cheap Cab Byculla to Pune",
description: "Cheap cab Byculla to Pune service offers budget-friendly transportation with reliable vehicles and professional drivers ensuring safe journeys."
},
{
name: "Byculla to Pune Outstation Cab",
description: "Byculla to Pune outstation cab service provides dependable long-distance travel with comfortable vehicles and experienced drivers."
},
{
name: "Byculla to Pune AC Taxi Service",
description: "Byculla to Pune AC taxi service offers comfortable air-conditioned travel for long-distance journeys ensuring a relaxed and pleasant experience."
}
],

tableData: [
["Byculla to Pune Cab Service Rates","Byculla to Pune Taxi Service"],
["Mahalaxmi to Pune Cab Service","Colaba to Pune Taxi"],
["Parel to Pune Cab Service","Sion to Pune Cab Booking"],
["Wadala to Pune Cab Booking","Byculla Cabs Service"],
["Outstation Cab Service in Byculla","Outstation Cab Service in Byculla Number"],
["Outstation Cab Service in Byculla Number Mumbai","Byculla to Pune Cab"],
["Byculla to Pune Cab Service","Byculla to Pune Taxi Service"],
["Byculla to Pune One Way Cab","Byculla to Pune Taxi Fare"],
["Byculla to Pune Cab Booking","Cab from Byculla to Pune"],
["Byculla to Pune Car Rental","Byculla to Pune Taxi Booking Online"],
["Cheap Cab Byculla to Pune","Byculla to Pune Outstation Cab"],
["Byculla to Pune AC Taxi Service","Byculla to Pune Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Byculla to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Byculla to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Byculla to Pune cab service operates 24 hours a day. Whether you need an early morning ride, business travel, airport transfer, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Byculla to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Byculla",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Byculla including Byculla East, Byculla West, and nearby South Mumbai locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Byculla to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Byculla to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Byculla to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Byculla from Pune?", answer: "The road distance between Byculla and Pune is approximately 155 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Byculla to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Byculla to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Byculla to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Byculla and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Byculla." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Byculla to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harshad Desai",
    feedback:
      "My journey from Byculla to Pune with Velocity Cabs was smooth and well-managed. The driver arrived on time, the cab was clean, and the ride was comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Bhosale",
    feedback:
      "Velocity Cabs provided excellent service for my Byculla to Pune travel. The vehicle was well-maintained, the driver was polite, and the trip was completed safely and without any delays.",
    rating: 5
  }
];































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const bycullaToPuneJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Byculla to Pune Cab Service | Velocity Cabs",
  "description": "Book reliable Byculla to Pune cab with Velocity Cabs. Cars available: Innova, SUV, Sedan. One-way, round trips, and AC taxi options. Affordable fares with 24x7 service.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Byculla, Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Byculla to Pune Taxi",
    "One-way Cab Byculla to Pune",
    "Round Trip Cab Service",
    "Outstation Taxi",
    "Airport Drop/Pickup",
    "AC Taxi Service"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Byculla to Pune Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book reliable Byculla to Pune cab with Velocity Cabs. Innova, SUV, Sedan available for one-way, round trip, and AC taxi options. Affordable fares & 24x7 service."
  />
  <script type="application/ld+json">
    {JSON.stringify(bycullaToPuneJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/62.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bycullatopunecab;